import { endOfMonth, format, parseISO, startOfMonth } from 'date-fns'

import type { DatePeriod } from './types'

const ISO_DAY = 'yyyy-MM-dd'

export const MONTHS_IN_YEAR = 12

export const monthPeriod = (year: number, monthIndex: number): DatePeriod => {
  const firstDay = new Date(year, monthIndex, 1)
  return {
    start: format(startOfMonth(firstDay), ISO_DAY),
    end: format(endOfMonth(firstDay), ISO_DAY),
  }
}

export const formatPeriod = (period: DatePeriod | null) => {
  if (!period) return 'No dates'
  const start = parseISO(period.start)
  const end = parseISO(period.end)
  const startPattern =
    start.getFullYear() === end.getFullYear() ? 'MMM d' : 'MMM d, yyyy'
  return `${format(start, startPattern)} to ${format(end, 'MMM d, yyyy')}`
}

export const formatPeriodShort = (period: DatePeriod) =>
  `${format(parseISO(period.start), 'MMM d')} to ${format(parseISO(period.end), 'MMM d')}`

export const formatMonth = (isoDay: string) =>
  format(parseISO(isoDay), 'MMM yyyy')

export const monthShortName = (monthIndex: number) =>
  format(new Date(2025, monthIndex, 1), 'MMM')

// A cycle is filed under the month it closes in, the same month the live coverage grid paints it
// in, so an Aug 31 to Sep 30 cycle is the September statement on both screens.
export const filedYear = (period: DatePeriod) =>
  parseISO(period.end).getFullYear()

export const filedMonthIndex = (period: DatePeriod) =>
  parseISO(period.end).getMonth()

export const sameMonthFiled = (one: DatePeriod, other: DatePeriod) =>
  filedYear(one) === filedYear(other) &&
  filedMonthIndex(one) === filedMonthIndex(other)
